const columnWidth = 71;

export const columns = [
  {
    Header: 'Family Size',
    accessor: 'FamilySize',
    minWidth: 75,
    filterable: false,
  },
  {
    Header: 'REDUCED PRICE MEALS',
    columns: [
      {
        Header: 'Annual',
        accessor: 'ReducedAnnual',
        minWidth: columnWidth,
      },
      {
        Header: 'Monthly',
        accessor: 'ReducedMonthly',
        minWidth: columnWidth,
      },
      {
        Header: 'Twice Per Month',
        accessor: 'ReducedTwicePerMonth',
        minWidth: columnWidth,
      },
      {
        Header: 'Every Two Weeks',
        accessor: 'ReducedEveryTwoWeeks',
        minWidth: columnWidth,
      },
      {
        Header: 'Weekly',
        accessor: 'ReducedWeekly',
        minWidth: columnWidth,
      },
    ],
  },
  {
    Header: 'FREE PRICE MEALS',
    columns: [
      {
        Header: 'Annual',
        accessor: 'FreeAnnual',
        minWidth: columnWidth,
      },
      {
        Header: 'Monthly',
        accessor: 'FreeMonthly',
        minWidth: columnWidth,
      },
      {
        Header: 'Twice Per Month',
        accessor: 'FreeTwicePerMonth',
        minWidth: columnWidth,
      },
      {
        Header: 'Every Two Weeks',
        accessor: 'FreeEveryTwoWeeks',
        minWidth: columnWidth,
      },
      {
        Header: 'Weekly',
        accessor: 'FreeWeekly',
        minWidth: columnWidth,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/pages/incomebracket/helpers/columns.js